export const GET_SHEET = "GET_SHEET"

export const ADD_NEW_SHEET = "ADD_NEW_SHEET"
export const STORE_TO_IMAGE_LIST = "STORE_TO_IMAGE_LIST"
export const STORE_SHEET_DATAS = "STORE_SHEET_DATAS"
export const RESET_SHEET_DATAS = "RESET_SHEET_DATAS"
